export default __webpack_public_path__ + "static/media/smile.392d1255.svg";